export default __webpack_public_path__ + "static/media/supportMaterial.05d704d9.svg";